/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_NewInputs */

const vi_grower_new = /** @type {(inputs: Grower_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm hộ trồng`)
};

/**

* @param {Grower_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_new = /** @type {((inputs?: Grower_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_new(inputs)
});